import { arrayToQueryString } from '../../utils/ApiUtils';

import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';

export default {
  get: (id: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/employees/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getByIds: (ids: string[] = []): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/employees${arrayToQueryString('ids', ids)}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAll: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/employees`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getLegacyUser: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/user/show/{user(id:${id}){ id, username, email, enabled, typeUser{ firstname, lastname, phoneNumber, dateCreate, entryDate, profileImage }}}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getLegacyCurrentUser: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/user/currentUser/{ user{ id, username, typeUser{ id, profileImage, firstname, lastname } }}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getNewCrmEmployeeId: (legacyId: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/api/v2/users/${legacyId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAgencyEmployees: (agencyId: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/employees?agencyId=${agencyId}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  me: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/employees/me`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getToken: (username: string, password: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/auth/get-token`,
    method: 'POST',
    body: JSON.stringify({ username, password }),
    headers: { 'Content-Type': 'application/json' },
  }),
  refreshToken: (refreshToken: string): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/employee-access/auth/refresh-token`,
    method: 'POST',
    body: JSON.stringify({ refreshToken }),
    headers: { 'Content-Type': 'application/json' },
    credentials: 'omit',
  }),
};
